<template>
    <div>
        <div class="p-fluid p-formgrid p-grid"> 
            <div class="p-field p-col-12 p-md-2">
                <label>Data Início</label>
                <Calendar v-model="dataInicio" dateFormat="dd/mm/yy" 
                    :manualInput="false" :showIcon="true"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label>Data Final</label>
                <Calendar v-model="dataFinal" dateFormat="dd/mm/yy" 
                    :manualInput="false" :showIcon="true"/>
            </div>   
            <div class="p-field p-col-0">
                <Button icon="pi pi-refresh" title="Atualizar" style="margin-top: 26px;" @click="losgManutencao"/>         
            </div>                                           
        </div>   
        <DataTable :value="logs" :filters="filtro" :paginator="true" :rows="10"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,31]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
            class="p-datatable-sm p-datatable-striped">
            <template #header>
                <div class="table-header">			
                    <div class="p-d-flex p-jc-end">				
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                        </span>
                    </div>
                </div>
            </template>
            <Column field="dia" header="Dia" sortable></Column>
            <Column field="inicioProcesso" header="Início" sortable></Column>
            <Column field="finalProcesso" header="Final" sortable></Column>
            <Column field="sucesso" header="Status" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.sucesso ? 'Sucesso' : 'Erro' }}
                </template>
            </Column>
            <Column field="mensagem" header="Mensagem" sortable></Column>
            <Column field="tipo" header="Tipo" sortable></Column>	
        </DataTable>  
    </div>
</template>

<script>

import LogsManutencaoService from '@/service/LogsManutencaoService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    logsManutencaoService: null,
    data() {
        return {
            dataInicio: new Date(),
            dataFinal: new Date(),  
            logs: [],
            filtro: {},          
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),  
        /**
         * 
         */
         losgManutencao() {
            this.logsManutencaoService.losgManutencao(this.formatarData(this.dataInicio), this.formatarData(this.dataFinal))
			.then(resp => {		               
                this.logs = resp.data;
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },        
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		}     
    },    
    created() {
        this.logsManutencaoService = new LogsManutencaoService();        
        this.losgManutencao();
    }
}
</script>

<style>
</style>